import {
  catalogApiRef,
  EntityRefLinks,
  useEntity,
} from '@backstage/plugin-catalog-react';
import { useMemo } from 'react';
import useAsync from 'react-use/esm/useAsync';

import { useApi } from '@backstage/core-plugin-api';

export function RelatedAccountsLinks() {
  const { entity } = useEntity();
  const workloadName = entity.metadata.labels?.workload || '';

  const tags = useMemo(() => {
    return (
      entity.metadata.tags?.filter(tag => tag === 'aws' || tag === 'azure') ||
      []
    );
  }, [entity]);

  const catalogApi = useApi(catalogApiRef);
  const { value: catalogResponse } = useAsync(() => {
    return catalogApi.getEntities({
      filter: {
        kind: ['Resource'],
        'metadata.labels.workload': [workloadName],
        'spec.type': 'account',
        'metadata.tags': tags,
      },
    });
  }, [catalogApi]);

  const relatedAccountEntities = useMemo(() => {
    return (catalogResponse?.items || []).filter(
      catalogItem => catalogItem.metadata.name !== entity.metadata.name,
    );
  }, [catalogResponse, entity]);

  return <EntityRefLinks entityRefs={relatedAccountEntities} />;
}
